import { Helper } from '@rawlings/core';

export class SurveyResponseDto {
    //#region Public Variables
    public SurveyResponseId: number = null;
    public Date: Date = null;
    public DayTimePhone: string = null;
    public Email: string = null;
    public Username: string = null;
    public IsOtherInsurance: boolean = null;
    public IsMedicare: boolean = null;
    public IsAcknowledge: boolean = null;
    public IsSigned: boolean = null;


    //#endregion Public Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    constructor(item?: any) {
        Helper.Construct(item, this);
    }
    //#endregion Constructor

    //#region Public Methods
    //#endregion Public Methods

    //#region Private Methods
    //#endregion Private Methods
}
